<template>
	<el-tabs v-model="activeName" @tab-click="handleClick">
		<!-- 纯电车 -->
		<el-tab-pane :label="$t('巡检.纯电车')" name="first">
			<VehicleChecklist 
				ref="pureElectric" 
				:title="$t('巡检.纯电车车辆检查表')" 
				:tree-data="pureElectricData" 
				:default-checked-keys="pureElectricCheckedKeys"
			/>
		</el-tab-pane>

		<!-- 非纯电车 -->
		<el-tab-pane :label="$t('巡检.非纯电车')" name="second">
			<VehicleChecklist 
				ref="nonPureElectric" 
				:title="$t('巡检.非纯电车车辆检查表')"
				:tree-data="nonPureElectricData" 
				:default-checked-keys="nonPureElectricCheckedKeys"
			/>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import VehicleChecklist from "../../vehicleInspection/inspectionSetting/components/VehicleChecklist.vue";
import { mapState } from 'vuex';

export default {
	name:"inspectionsetting",
	components: { VehicleChecklist },
	data() {
		return {
			activeName: "first",
			pureElectricData: [], // 纯电车树形数据
			nonPureElectricData: [], // 非纯电车树形数据
			pureElectricCheckedKeys: [], // 纯电车默认选中节点ID
			nonPureElectricCheckedKeys: [] // 非纯电车默认选中节点ID
		};
	},
	computed: {
		size() { return this.$store.getters.size },
		...mapState({
			operator: state => state.user.operator,
		}),
	},
	mounted() {
		this.getSetList();
	},
	methods: {
		handleClick(tab) {
			console.log('切换到标签:', tab.name);
			// 移除重置编辑状态的代码
		},

		convertFlatToTree(flatArr) {
			const idMap = {};
			flatArr.forEach(item => {
				idMap[item.ItemID] = {
					id: item.ItemID,
					label: item.Title,
					children: [],
					sortOrder: item.SortOrder,
					disabled: true // 初始状态为禁用
				};
			});
		
			const tree = [];
			flatArr.forEach(item => {
				const currentNode = idMap[item.ItemID];
				if (item.PItemID === 0) {
					tree.push(currentNode);
				} else {
					const parentNode = idMap[item.PItemID];
					if (parentNode) {
						parentNode.children.push(currentNode);
					}
				}
			});
		
			const sortTree = (nodes) => {
				return nodes.sort((a, b) => a.sortOrder - b.sortOrder).map(node => {
					if (node.children.length) {
						node.children = sortTree(node.children);
					}
					return node;
				});
			};
		
			return sortTree(tree);
		},

		 getSetList() {
		    // 定义接口参数（公司ID + 车辆类型）
		    const companyId = this.operator.CompanyId.toString();
		    const pureElectricParams = {
		      CompanyID: companyId,
		      VehicleEnergyType: "纯电车" // 纯电车参数
		    };
		    const nonPureElectricParams = {
		      CompanyID: companyId,
		      VehicleEnergyType: "非纯电车" // 非纯电车参数
		    };
		
		    // 并行调用两个接口，分别获取纯电和非纯电数据
		    Promise.all([
		      this.$api.queryInspectionDefault(pureElectricParams),
		      this.$api.queryInspectionDefault(nonPureElectricParams)
		    ]).then(([pureRes, nonPureRes]) => {
		      // 处理纯电车数据
		      if (pureRes.code === 200 && Array.isArray(pureRes.data)) {
		        const pureFlatData = pureRes.data;
		        this.pureElectricData = this.convertFlatToTree(pureFlatData);
		        this.pureElectricCheckedKeys = pureFlatData
		          .filter(item => item.IsEnabled === 1)
		          .map(item => item.ItemID);
		      } else {
		        this.pureElectricData = [];
		        this.pureElectricCheckedKeys = [];
		        this.$message.warning(`${this.$t("巡检.纯电车")}${this.$t("vehicletrack.nonTrackTip")}`);
		      }
		
		      // 处理非纯电车数据
		      if (nonPureRes.code === 200 && Array.isArray(nonPureRes.data)) {
		        const nonPureFlatData = nonPureRes.data;
		        this.nonPureElectricData = this.convertFlatToTree(nonPureFlatData);
		        this.nonPureElectricCheckedKeys = nonPureFlatData
		          .filter(item => item.IsEnabled === 1)
		          .map(item => item.ItemID);
		      } else {
		        this.nonPureElectricData = [];
		        this.nonPureElectricCheckedKeys = [];
		        this.$message.warning(`${this.$t("巡检.非纯电车")}${this.$t("vehicletrack.nonTrackTip")}`);
		      }
		
		      console.log("纯电车树形数据：", this.pureElectricData);
		      console.log("非纯电车树形数据：", this.nonPureElectricData);
		    }).catch((err) => {
		      console.error("接口调用失败：", err);
		      this.$message.warning(this.$t("vehicletrack.nonTrackTip"));
		    });
		  }
	}
};
</script>

<style>
/* 父组件样式（若有） */
</style>